@if (isSpinnerVisible) {
  <div class="seat-layout-loader">
    <div class="c-loader">
      <div class="c-loader-inner">
        <div class="loader"></div>
      </div>
      </div><span class="close-button ixi-icon-cross"></span>
    </div>
  }